import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { UserPlus, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo-tecnologie.webp';

export default function Register() {
  const nav = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({ brand_name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) return toast.error('Password troppo corta (min 6 caratteri)');
    setLoading(true);
    try {
      await register(form.email, form.password, form.brand_name);
      toast.success('Registrazione completata!', { description: 'Ora puoi personalizzare il tuo brand.' });
      nav('/account/brand');
    } catch (err) {
      const detail = err?.response?.data?.detail || '';
      if (detail === 'email_already_registered') toast.error('Email già registrata');
      else toast.error('Errore nella registrazione');
    } finally { setLoading(false); }
  };

  return (
    <div className="tv-gradient-soft min-h-[80vh] py-14">
      <div className="mx-auto max-w-md px-4 sm:px-6">
        <div className="text-center mb-6">
          <img src={logo} alt="Tecnologie" className="h-10 mx-auto" />
          <div className="mt-1 text-[11px] uppercase tracking-widest text-[#0d63b0] font-semibold">Secure Push · Diventa Reseller</div>
        </div>
        <Card className="border border-slate-200 p-7">
          <h1 className="text-2xl font-extrabold text-slate-900">Crea il tuo brand</h1>
          <p className="mt-1 text-sm text-slate-600">Rivendi Secure Push ai tuoi clienti con il tuo marchio. Piano Free per partire subito.</p>
          <form onSubmit={submit} className="mt-5 space-y-4">
            <div>
              <Label>Nome brand / azienda</Label>
              <Input required value={form.brand_name} onChange={(e) => setForm((f) => ({ ...f, brand_name: e.target.value }))} placeholder="Es. Acme IT" className="mt-1" />
              <p className="mt-1 text-[11px] text-slate-500">Sarà usato per l'URL: /b/nome-brand/p/...</p>
            </div>
            <div>
              <Label>Email amministratore</Label>
              <Input type="email" required value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} placeholder="admin@azienda.it" className="mt-1" />
            </div>
            <div>
              <Label>Password</Label>
              <Input type="password" required minLength={6} value={form.password} onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))} placeholder="Minimo 6 caratteri" className="mt-1" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 bg-[#0d63b0] hover:bg-[#0a4f8f] text-white">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : (<><UserPlus className="h-4 w-4 mr-1.5" /> Crea account gratuito</>)}
            </Button>
            <div className="text-[11px] text-slate-500 text-center">Registrandoti accetti termini e privacy. Nessun addebito automatico — il piano parte da Free.</div>
          </form>
          <div className="mt-5 pt-5 border-t border-slate-100 text-sm text-slate-600 text-center">
            Hai già un account?{' '}
            <Link to="/login" className="font-semibold text-[#0d63b0] hover:underline">Accedi</Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
